import alphaFitnessLarge from '../images/alphafitness-details.PNG';
import alphaFitness from '../images/alphafitness.PNG';
import sigmaLarge from '../images/sigma-details.PNG';
import sigma from '../images/sigma.PNG';
import tripnowLarge from '../images/tripnow-details.PNG';
import tripNow from '../images/tripnow.PNG';
const fullstackProjects = [
    {
        id: 1,
        name: "Sigma - Full Stack Wrist Watch Website",
        image: sigma,
        imageLarge: sigmaLarge,
        description: "A MERN stack site where users can signin using Google, Github or Email. Admin can manage orders, add or delete products and make another admin. Users can manage purchases and add reviews. Secure admin and user routes using JWT authentication.",
        live: "https://sigma-sakib.netlify.app/home",
        client: "https://github.com/ShakibUddin/Sigma-Client",
        server: "https://github.com/ShakibUddin/Sigma-Server",
        technologies: ["React.js", "Tailwind CSS", "Express", "MongoDB", "Firebase"],
        screenShots: ["https://i.ibb.co/Fx3FRdP/2.png", "https://i.ibb.co/VvTqcNT/3.png", "https://i.ibb.co/Y7gcVvT/5.png"],
        bulletPoints: ["Google, Github, Email login feature using Firebase",
            "Admin can approve or delete orders", "Delete products", "Only Admin make another user admin",
            "Users can manage purchases and add reviews",
            "Secure admin and user routes using JWT authentication"
        ]
    },
    {
        id: 2,
        name: "Alpha Fitness - Full Stack Gym Website",
        image: alphaFitness,
        imageLarge: alphaFitnessLarge,
        description: "A MERN stack site where users can signin using Google, Github or Email. Admin can manage purchases, appointments, and queries from users. Users can purcahse gym membersjips, book consultation session with fitness experts. It Has email notification system.",
        live: "https://alpha-fitness-sakib.netlify.app/",
        client: "https://github.com/ShakibUddin/Alpha-Fitness",
        server: "https://github.com/ShakibUddin/Alpha-Fitness-Server",
        technologies: ["React.js", "Tailwind CSS", "Express", "MongoDB", "Firebase", "Nodemailer"],
        screenShots: ["https://i.ibb.co/ZJmwYVV/2.png",
            "https://i.ibb.co/QKwPLnr/consultation.png",
            "https://i.ibb.co/zPXxhvC/5.png"
        ],
        bulletPoints: ["Google, Github, Email login feature using Firebase",
            "Admin dashboard", "Admin can approve, delete appointments", 'Admin can delete or reply to queries',
            "Users book appointments",
            "Users purchase memberships",
        ]
    },
    {
        id: 3,
        name: "Trip Now - Full Stack Trip Booking Website",
        image: tripNow,
        imageLarge: tripnowLarge,
        description: "A MERN stack site where users can signin using Email. User can find the trips they like and book it. Admins can approve or delete a trip order. Users can also delete there trips. Admin can add a new trip",
        live: "https://tripnow.netlify.app/",
        client: "https://github.com/ShakibUddin/Trip-Now-Client",
        server: "https://github.com/ShakibUddin/Trip-Now-Server",
        technologies: ["React.js", "Tailwind CSS", "Express", "MongoDB", "Firebase"],
        screenShots: ["https://i.ibb.co/prRTHmk/1.png", "https://i.ibb.co/gTgL0w7/2.png", "https://i.ibb.co/MV2fkXD/3.png"
        ],
        bulletPoints: ["Email login feature using Firebase",
            "Admin can approve or delete trip bookings", "Admin can add trips", "Users can book trip", "Users can cancel the trip they booked"
        ]
    }
];

export default fullstackProjects;